import React from 'react';
import { useTranslation } from 'react-i18next';

import { getServices_bookableServices } from 'Book/pages/Book/hooks';
import { groupServices } from '../../lib';
import { ServiceGroup } from '../ServiceGroup';

export default ({
  bookableServices,
}: {
  bookableServices: getServices_bookableServices[];
}) => {
  const { t } = useTranslation('book', { keyPrefix: 'book' });

  const { practical, coaching, other } = groupServices(
    bookableServices || [],
    t,
  );

  return (
    <>
      {practical && <ServiceGroup {...practical} />}
      {coaching && <ServiceGroup {...coaching} />}
      {other && <ServiceGroup {...other} />}
    </>
  );
};
